/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import {  Container } from "@material-ui/core";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import CircularProgress from "@mui/material/CircularProgress";
import ActionRender from "../../ActionRender";
import AuthContext from "../../../../hooks/authContext";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Button } from "../../../../components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import { Label } from "../../../../components/ui/label";
import { Download, FileSpreadsheet, FileText, Filter, Mail, MessageSquare, Users } from "lucide-react";
import { getCompanyEmployees, getEmployee } from "../../../../services/apiservices/employee";
import ThemeTable from "../../../../components/Table/ThemeTable";
import EmailReports from "../../EmailReports";
import { CSVLink } from "react-csv";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { getMessageByDateandCompany } from "../../../../services/apiservices/notifications";
import { Badge } from "../../../../components/ui/badge";
import { MobileMessageSentEmpReport } from "../MobileViewReports";
import { getSettings } from "../../../../services/apiservices/settings";


function MessagesSenttoEmployee(props) {

    const csvHeaders = [
        "Employee Name",
         "Date",
        "Time",
        "Type",
        "Details",
        "Channel",
    ];

    const [employeeList, setEmployeeList] = useState([]);
    const [employeeListMaster, setEmployeeListMaster] = useState([]);
    const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [empName, setEmpName] = useState("All");
    const [employee, setEmployee] = useState();
    const [companyDetail, setCompanyDetail] = useState();
    const [openEmailDialog, setOpenEmailDialog] = useState(false);
    const [loader, setLoader] = useState(false);
    const [settingsData, setSettingsData] = useState();
    const [empNameList, setEmpNameList] = useState([
        { label: "All", value: "All" },
    ]);
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width:767px)');
    const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
    const auth = useContext(AuthContext);
    const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

    const getColumns = () => {
        const columns = [
            {
                id: "employeeName",
                numeric: false,
                disablePadding: false,
                label: "Employee",
                isSortable: false,
                gray:true,
            },
               {
                id: "date",
                numeric: false,
                disablePadding: false,
                label: "Date",
                isSortable: false,
                gray:true,
            },
            {
                id: "time",
                numeric: false,
                disablePadding: false,
                label: "Time",
                isSortable: false,
                gray:true,
            },
         
            {
                id: "type",
                numeric: false,
                disablePadding: false,
                label: "Type",
                isSortable: false,
                gray:true,
            },
            {
                id: "details",
                numeric: false,
                disablePadding: false,
                label: "Details",
                isSortable: false,
                gray:true,
            },
            {
                id: "channel",
                numeric: false,
                disablePadding: false,
                label: "Channel",
                isSortable: false,
                gray:true,
            },
            {
                id: "Action",
                numeric: false,
                disablePadding: false,
                label: "Action",
                isSortable: false,
                gray:true,
            },
        ];

        if (isMobile || isLandscape) {
            return columns.filter(col => col.id !== "employeeName" && col.id !== "appointmentDate" && col.id !== "Action");
        }

        return columns;
    };

    const getDatatoDownload = (rcellItem) => {
        let clientCSV = [];
        if (!Array.isArray(rcellItem)) {
            clientCSV = employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            clientCSV = clientCSV?.map((item) => {
                return [
                    item?.employeeName,
                     item?.date,
                    item?.time,
                    item?.type,
                    item?.details,
                    item?.channel,
                ];
            });
        } else {
            clientCSV = rcellItem?.map((item) => {
                return [
                      item?.employeeName,
                     item?.date,
                    item?.time,
                    item?.type,
                    item?.details,
                    item?.channel,
                ];
            });
        }
        return clientCSV;
    }

    const getDatatoFullDownload = (rcellItem) => {
        if (rcellItem) {
            employeeList?.filter(
                (item) => item.employeNameId === rcellItem.employeNameId
            );
            return [
                rcellItem?.employeeName,
                rcellItem?.date,
                rcellItem?.time,
                rcellItem?.type,
                rcellItem?.details,
                rcellItem?.channel,
            ];
        } else {
            return [
                 rcellItem?.employeeName,
                rcellItem?.date,
                rcellItem?.time,
                rcellItem?.type,
                rcellItem?.details,
                rcellItem?.channel,
            ];
        }
    }

    useEffect(() => {
      const getEmployeesData = async () => {
        const [employeeRes, empDetails, settingsRes] = await Promise.all([
          new Promise((resolve, reject) => {
            getCompanyEmployees(
              companyId,
              (res) => resolve(res),
              (err) => resolve({ status: false, data: [] })
            );
          }),
          new Promise((resolve) => getEmployee(companyId, resolve)),
          new Promise((resolve) =>
            getSettings("client_settings", (res) => resolve(res?.data))
          ),
        ]);
        const details = employeeRes?.data;
        const employee = details?.map((item) => {
          return {
            value: item?.id,
            label: `${item?.firstName} ${item?.lastName}`,
          };
        });
        const filteredData = settingsRes?.filter(
          (item) => item?.companyId === companyId && !item.deleted
        );
        setSettingsData(filteredData?.length ? filteredData : []);
        setCompanyDetail(empDetails?.data);
        setEmployee(details);
        setEmpNameList([{ label: "All", value: "All" }, ...employee]);
      };
      getEmployeesData();
    }, []);

    const downloadForExcel = async (rcellItem, emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Messages Sent to Employee Report');
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
        let fileName;
        if (rcellItem?.records) {
            fileName = `MessagesSenttoEmployeeReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `MessagesSenttoEmployeeReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }

    const downloadForPDF = async (rcellItem, emailSend) => {
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);
        let fileName;
        if (Array.isArray(rcellItem?.records)) {
            fileName = `MessagesSenttoEmployeeReport_${rcellItem?.records?.[0]?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        } else {
            fileName = `MessagesSenttoEmployeeReport_${rcellItem?.employeeName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
        }
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const setDownloadCSVData = (event, done, rcellItem) => {
        const clientCSV = getDatatoDownload(rcellItem?.records ? rcellItem?.records : rcellItem);

        const reportName = "Messages Sent to Employee Report";
        const employeName = Array.isArray(rcellItem) ? `${rcellItem?.records?.[0]?.employeeName}` : `${rcellItem?.employeeName}`;
        const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

        // Create the report details rows
        const reportDetails = [
            [`Employee Name: ${employeName}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];

        // Set the CSV data
        setClientListCSV(reportDetails);
        done();
    };

    const setDownloadFullCSVData = (event, done) => {
        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
        let empNamefordwonLoad = 'All'

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }

        const reportName = "Messages Sent to Employee Report";
        const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;

        const reportDetails = [
            [`Employee Name: ${empNamefordwonLoad}`],
            [`Report Name: ${reportName}`],
            [`Report Period: ${reportPeriod}`],
            [],
            [...csvHeaders],
            ...clientCSV
        ];

        setClientListCSV(reportDetails);
        done();
    };

    const downloadForFullPDF = async (emailSend) => {
        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));
        let empNamefordwonLoad = 'All'

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }
        let fileName = `MessagesSenttoEmployeeReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        const logo = settingsData?.[0]?.companyLogo;
        return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend, name);
    }

    const downloadForFullExcel = async (emailSend) => {
        let wb = new Excel.Workbook();
        let ws = wb.addWorksheet('Messages Sent to Employee Report');
        let empNamefordwonLoad = 'All'

        const clientCSV = employeeList.map((item) => getDatatoFullDownload(item));

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList?.filter((item) => item.value === empName)[0].label
        }
        let fileName = `MessagesSenttoEmployeeReport_${empNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
        let name = true;
        return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend, name)
    }


    const handleEmailIconClick = async (rcellItem) => {
        const emailSend = true;
        const excelBlob = await downloadForExcel(rcellItem, emailSend);
        let name;
        if (Array.isArray(rcellItem?.records)) {
            name = rcellItem?.records?.[0]?.employeeName;
        } else {
            name = rcellItem?.employeeName;
        }

        localStorage.setItem("FileName", "Messages Sent to Employee Report");

        localStorage.setItem("ReportsName", "Employee Report");

        localStorage.setItem("Name", name);

        localStorage.setItem("Date", startDate);

        localStorage.setItem("EndDate", endDate);

        const pdfBlob = await downloadForPDF(rcellItem, emailSend);
        localStorage.setItem("pdfData", pdfBlob);
        localStorage.removeItem("fullReport")
        localStorage.removeItem("fullExcelReport")
        setIsLoading(true);

        // Convert the Excel blob to a base64-encoded string
        const reader = new FileReader();
        reader.readAsDataURL(excelBlob);
        reader.onloadend = function () {
            const base64Data = reader.result;
            localStorage.setItem("emailData", base64Data);
            setOpenEmailDialog(true);
        };
    };


    const handelEmailFullReport = async () => {
        const emailSend = true;
        localStorage.setItem("FileName", "Messages Sent to Employee Report");

        localStorage.setItem("ReportsName", "Employee Report");

        let empNamefordwonLoad = 'All'

        if (empName !== 'All') {
            empNamefordwonLoad = empNameList.filter((item) => item.value === empName)[0].label
        }
        localStorage.setItem("Name", empNamefordwonLoad);

        localStorage.setItem("Date", startDate);

        localStorage.setItem("EndDate", endDate);

        setIsLoading(true);
        const fullReport = await downloadForFullPDF(emailSend);
        localStorage.setItem("fullReport", fullReport);
        localStorage.removeItem("pdfData")
        localStorage.removeItem("emailData")

        const fullExcelReport = await downloadForFullExcel(emailSend);
        const reader = new FileReader();
        reader.readAsDataURL(fullExcelReport);
        reader.onloadend = function () {
            const base64Data = reader.result;
            localStorage.setItem("fullExcelReport", base64Data);
            setOpenEmailDialog(true);
        }
    }

    const handleEmpNameChange = (e) => {

        const str = e;

        setEmpName(str);
        if (str === "All") {
            setEmployeeList(employeeListMaster);
        } else {
            setEmployeeList(() =>
                employeeListMaster.filter((itme) => {
                    let returnFlg = true;
                    if (returnFlg) {
                        returnFlg = str.includes(itme?.employeNameId);
                    }
                    return returnFlg;
                })
            );
        }
    };

    const handleGenerateReport = async() => {
        setLoader(true);
        let paramStartDate = "";
        let paramEndDate = "";

        paramStartDate = startDate;
        paramEndDate = endDate;
        getReportListData(paramStartDate, paramEndDate);
    }

    function getTypeLabel(input) {
      if (!input) return "";

      let arr = Array.isArray(input)
        ? input.map(s => String(s).trim())
        : [String(input).trim()];

      const lower = arr.map(s => s.toLowerCase());

      if (lower.includes("both")) {
        return "All";
      }

      const hasPush = lower.includes("pushnotification") || lower.includes("push");
      const hasEmail = lower.includes("email");

      if (hasPush && hasEmail) {
        return "PushNotification, Email";
      }
      if (hasPush) return "PushNotification";
      if (hasEmail) return "Email";

      return arr.join(", ");
    }

    const mapWidhtEmpList = async (timeSheet) => {
      const finaleData = timeSheet?.flatMap((resItem) => {
        return resItem?.Employee?.map((emp) => {
          const user = employee?.find((e) => e.id === emp.id);
          if (!user) return null;

          const newResItem = { ...resItem };
          newResItem.employeeName = `${user.firstName} ${user.lastName}`;
          newResItem.employeNameId = user.id;
          newResItem.date = moment(resItem?.createdOn).format("MMMM D, YYYY");
          newResItem.time = moment(resItem?.createdOn).format("HH:mm");
          newResItem.channel = getTypeLabel(resItem?.Type);
          newResItem.type =
            resItem?.Employee?.length === 1 ? "Single" : "Multiple";
          newResItem.details = resItem?.Message;
          newResItem.company = `${companyDetail?.firstName} ${companyDetail?.lastName}`;

          return newResItem;
        }).filter(Boolean);
      });
      let sortedData = sortingFunction(finaleData);
      setEmployeeListMaster(sortedData);

      setEmployeeList(() =>
        sortedData?.filter((itme) => {
          let returnFlg = true;
          if (empName !== "All" && returnFlg) {
            returnFlg = itme.employeNameId === empName;
          }
          return returnFlg;
        })
      );
      setLoader(false);
    };

    const sortingFunction = (data) => {
        const result = data?.sort((a, b) => {
            if (a.employeeName < b.employeeName) return -1;
            if (a.employeeName > b.employeeName) return 1;

            if (a.appointmentDateTime < b.appointmentDateTime) return -1;
            if (a.appointmentDateTime > b.appointmentDateTime) return 1;
            return 0;
        });

        return result;
    };

    const getReportListData = async (startDt, endDt) => {
        const param = {
            startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
            endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
        };

        getMessageByDateandCompany(
            param,
            companyId,
            (result) => {
                const data = result;
                setIsLoading(false);
                mapWidhtEmpList(data);
            },
            (err) => {
                setIsLoading(false);
                console.log("err>>", err);
            }
        );
    };

    const renderRowCell = (rcellItem, hcellItem, index, rowindex) => {
        switch (hcellItem.id) {
            case "employeeName":
                if (
                    rowindex !== 0 &&
                    employeeList[rowindex - 1].employeeName !== rcellItem.employeeName
                ) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else if (rowindex === 0) {
                    return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
                } else {
                    return "";
                }
            case "details":
              return (
                <Tooltip>
                  <TooltipTrigger asChild>
                    <div className="max-w-32 truncate cursor-pointer">
                      {rcellItem?.details}
                    </div>
                  </TooltipTrigger>
                  <TooltipContent>
                    <div className="max-w-64">
                      <p>{rcellItem?.details}</p>
                    </div>
                  </TooltipContent>
                </Tooltip>
              );
            case "type":
              return rcellItem?.type === "Multiple" ? (
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <div className="flex items-center gap-1 cursor-pointer">
                        <Users className="h-4 w-4" />
                        <span>Multiple</span>
                      </div>
                    </TooltipTrigger>
                    <TooltipContent>
                      <div className="max-w-48">
                        <p className="font-semibold mb-4">Recipients:</p>
                        <ul className="text-sm space-y-1">
                          {rcellItem?.Employee?.map((recipient, index) => (
                            <li key={index}>• {recipient?.name}</li>
                          ))}
                        </ul>
                      </div>
                    </TooltipContent>
                  </Tooltip>
              ) : (
                "Single"
              );
            case "channel": 
            return(
              rcellItem?.channel?.split(",")?.map((ch, idx) => (
                <Badge key={idx} variant="outline" className="mh-3">
                  {ch?.trim()}
                </Badge>
              ))
            )
            case "Action":
                if (isMobile || isLandscape) {
                    if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"MessagesSenttoEmployeeReport"}
                            />
                        );
                    } else {
                        return null;
                    }
                } else {
                    if (
                        rowindex !== 0 &&
                        employeeList[rowindex - 1].employeNameId !== rcellItem.employeNameId
                    ) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"MessagesSenttoEmployeeReport"}
                            />
                        );
                    } else if (rowindex === 0) {
                        return (
                            <ActionRender
                                rcellItem={rcellItem}
                                clientsListCSV={clientsListCSV}
                                setDownloadCSVData={setDownloadCSVData}
                                downloadPDF={downloadForPDF}
                                downloadExcel={downloadForExcel}
                                startDate={startDate}
                                endDate={endDate}
                                handleEmailIconClick={handleEmailIconClick}
                                name={"MessagesSenttoEmployeeReport"}
                            />
                        );
                    } else {
                        return "";
                    }
                }
            default:
                return <div className="b-none">{rcellItem[hcellItem?.id]}</div>;
        }
    };

    const MobileViewData = useMemo(() => {
        if (!employeeList?.length) return [];

        return employeeList?.reduce((acc, item) => {
            const employeeName = item?.employeeName;

            const record = {
            id: item?.id,
            date: item?.date,
            time: item?.time,
            channel: item?.channel,
            type: item?.type,
            details: item?.details,
            employeNameId: item?.employeNameId,
            employeeName: item?.employeeName,
            };

            const existingGroup = acc?.find((g) => g?.employeeName === employeeName);

            if (existingGroup) {
            existingGroup?.records?.push(record);
            } else {
            acc?.push({
                employeeName,
                records: [record],
            });
            }

            return acc;
        }, []);
    }, [employeeList]);

    const filteredEmployee = employee?.find((item) => item?.id === empName);

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }

    return (
      <>
        <Container>
          <PageTitle
            pageTitle="Messages Sent to Employee Reports"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Reports" },
              { label: "New Reports" },
              { label: "Employee Reports", to: "/reports/newreport/employeereport" },
            ]}
            BreadCrumbCurrentPageTitle={"Messages Sent to Employee Reports"}
            showLastSeen={true}
          ></PageTitle>

          <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
              <div className="space-y-6">
                <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                  <CardHeader className="pb-12">
                    <div className="flex items-center space-x-2">
                      <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      <CardTitle className="text-lg sm:text-xl">
                        Report Parameters
                      </CardTitle>
                    </div>
                    <CardDescription className="text-left text-sm sm:text-base">
                      Configure the parameters for your Messages Sent to Employee Report
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                     <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                      {/* Employee Select */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="employee"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Employee Name *
                        </Label>
                        <SingleSelectNew
                          value={empName}
                          name="employeeName"
                          label="Employee Name"
                          onChange={(e) => handleEmpNameChange(e)}
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          options={empNameList}
                          className="w-full min-h-[40px] px-3 py-2"
                        />
                      </div>

                      {/* Start Date */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="startDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Start Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              if (newValue) {
                                setEndDate(moment());
                              } else {
                                setEndDate(null);
                              }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      {/* End Date */}
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="endDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          End Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              if (!newValue) {
                                setStartDate(null);
                              }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="flex justify-start sm:justify-end pt-8">
                      <Button
                        type="submit"
                        className="w-full sm:w-auto h-10 text-sm px-6"
                        onClick={() => handleGenerateReport()}
                      >
                        {loader ? (
                          <CircularProgress
                            size={28}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <span className="d-flex flex-center">
                            <FileText className="w-4 h-4 mr-8" /> Generate
                            Report
                          </span>
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
                {loader ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      Fetching report data...
                    </div>
                  </Card>
                ) : employeeList?.length === 0 ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      No Records Found
                    </div>
                  </Card>
                ) : (
                  employeeList?.length > 0 && (
                    <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                      <CardHeader className="pb-16">
                        <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                          <div className="space-y-3 flex-1 min-w-0">
                          <div className="flex items-center space-x-2">
                             <MessageSquare className="w-4 h-4 sm:w-5 sm:h-5 text-dark" />
                            <CardTitle className="text-lg sm:text-xl">
                            Messages Sent Report Results
                            </CardTitle>
                            </div>
                            <CardDescription className="space-y-2">
                              <div className="font-medium text-sm sm:text-base">
                                {empName === "All"
                                  ? "All Employees Report"
                                  : `Employee Report for ${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`}
                              </div>
                              <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                              </div>
                            </CardDescription>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handelEmailFullReport()}
                              className="h-8"
                            >
                              <Mail className="mr-4 h-3 w-3" />
                              Email Report
                            </Button>
                            <Popover>
                              <PopoverTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-8"
                                >
                                  <Download className="mr-4 h-3 w-3" />
                                  Download
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-40">
                                <div className="space-y-2">
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullPDF()}
                                  >
                                    <FileText className="mr-8 h-3 w-3" />
                                    PDF
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullExcel()}
                                  >
                                    <FileSpreadsheet className="mr-8 h-3 w-3" />
                                    Excel
                                  </Button>
                                  <CSVLink
                                    data={clientsListCSV}
                                    filename={`MessagesSenttoEmployeeReport_${
                                      empName === "All"
                                        ? "All"
                                        : `${filteredEmployee?.firstName} ${filteredEmployee?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                      setDownloadFullCSVData(event, done);
                                    }}
                                    className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                  >
                                    <FileSpreadsheet className="mr-16 h-4 w-4" />
                                    <span className="font-medium">CSV</span>
                                  </CSVLink>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0 sm:p-6 sm:pt-0">
                        {!isMobile && (
                        <TooltipProvider>
                          <ThemeTable
                            rows={employeeList}
                            headCells={getColumns()}
                            hidePagination={true}
                            // isLoading={isLoading}
                            renderRowCell={renderRowCell}
                            />
                        </TooltipProvider>
                        )}
                        {isMobile && (
                          <MobileMessageSentEmpReport
                            MobileViewData={MobileViewData}
                            handleEmailIconClick={handleEmailIconClick}
                            downloadForPDF={downloadForPDF}
                            downloadForExcel={downloadForExcel}
                            clientsListCSV={clientsListCSV}
                            setDownloadCSVData={setDownloadCSVData}
                            startDate={startDate}
                            endDate={endDate}
                            reportName={"MessagesSenttoEmployeeReport"}
                          />
                        )}
                      </CardContent>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
          <EmailReports
            open={openEmailDialog}
            onClose={() => handleEmailDialogClose()}
          />
        </Container>
      </>
    );

}
export default MessagesSenttoEmployee;